module.exports = __webpack_public_path__ + "img/71.36354e4a.png";